module.exports = __webpack_public_path__ + "img/9788997889969.28f83702.jpg";